import PropTypes from 'prop-types';
import React from 'react';

import CardText from 'components/Card/Text';
import CardTitle from 'components/Card/Title';

import SecondaryButton from './SecondaryButton';

const Verify = ({ message, onLogin }) => (
  <>
    <CardTitle title='Verify Your Email' />
    <CardText noTopPadding>
      {message}
    </CardText>
    <CardText noTopPadding>
      <SecondaryButton
        label='Back to login'
        onClick={onLogin}
      />
    </CardText>
  </>
);

Verify.propTypes = {
  message: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
};

export default Verify;
